module.exports = __webpack_public_path__ + "img/loss analysis - sf.b37966e1.gif";